const DocumentIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M9.9974 1.33301H3.9974C3.64377 1.33301 3.30464 1.47348 3.05459 1.72353C2.80454 1.97358 2.66406 2.31272 2.66406 2.66634V13.333C2.66406 13.6866 2.80454 14.0258 3.05459 14.2758C3.30464 14.5259 3.64377 14.6663 3.9974 14.6663H11.9974C12.351 14.6663 12.6902 14.5259 12.9402 14.2758C13.1903 14.0258 13.3307 13.6866 13.3307 13.333V4.66634L9.9974 1.33301Z'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.33594 1.33301V3.99967C9.33594 4.3533 9.47641 4.69244 9.72646 4.94248C9.97651 5.19253 10.3156 5.33301 10.6693 5.33301H13.3359'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.66927 6H5.33594'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6693 8.66699H5.33594'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6693 11.333H5.33594'
        stroke='white'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default DocumentIcon
